import { supportedLocale } from './dayjs.js';
import { dateInputFormats } from './DefaultDateFormatter.js';
import { timeInputFormats, timeDisplayFormat } from './DefaultTimeFormatter.js';
import dayjs from 'dayjs';

function getDateTimeInputFormats(dsmsy) {
  const dateFormats = dateInputFormats(dsmsy);
  const timeFormats = timeInputFormats();
  const dateTimeFormats = [];
  for (const dateFormat of dateFormats) {
    for (const timeFormat of timeFormats) {
      dateTimeFormats.push(dateFormat + ' ' + timeFormat);
    }
    dateTimeFormats.push(dateFormat);
  }
  return dateTimeFormats.concat(timeFormats);
}
class DefaultDateTimeFormatter {
  constructor(languageCode, locale) {
    this.locale = supportedLocale(languageCode);
    this.dateFormat = locale.dateFormat;
    this.timeFormat = locale.timeFormat;
    this.inputFormats = getDateTimeInputFormats(this.dateFormat);
  }
  parse(displayDate) {
    let date = dayjs(displayDate, this.inputFormats, this.locale, true);
    if (!date.isValid()) {
      date = dayjs(displayDate, this.inputFormats, this.locale, false);
    }
    return date.isValid() ? date.toISOString() : displayDate;
  }
  /* eslint-disable @typescript-eslint/no-unused-vars */
  /* eslint-disable no-unused-vars */
  format(isoDateTime, useSeconds, _dateTimeIsLocal) {
    const date = dayjs(isoDateTime);
    return date.isValid() ? date.locale(this.locale).format(this.displayFormat(useSeconds)) : isoDateTime;
  }
  displayFormat(useSeconds) {
    return this.dateFormat + ' ' + timeDisplayFormat(useSeconds, this.timeFormat);
  }
}

export { DefaultDateTimeFormatter as default };
